export default __webpack_public_path__ + "static/media/Skärmavbild 2020-12-15 kl. 07.48.07.f3c5a898.png";